import React, { useCallback } from 'react'
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';


const WorkflowTest = () => {
  const style         = SideStyle();
  const activeStep    = Param.Get('activeStep');
  const align         = Param.Get('align');
  const compress      = Param.Get('compress');
  const thick         = Param.Get('thick');
  const trim          = Param.Get('trim');
  const setParam      = Param.Get('setParam');

  const meshSocketModify = Control.Get('meshSocketModify');

  /**
   * Sets the active step in the workflow.
   */
  const onClick = useCallback((step) => {
    setParam(s => {s.activeStep = step});
  })
  
  /**
   * Returns the class name for the button based on the active step.
   * @param {number} step - The step number to check against the active step.
   * @returns {string} - The class name for the button.
   */
  const getActive = (step) => {
    if (step == 2) { // for marking
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= 1 && align.step >= 3) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    } else if (step == 4) { // for compression
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= 3 && meshSocketModify) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    } else if (step == 5) { // for compress
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= 3 && compress.step >= 1) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    } else if (step == 6) { // for trimming
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= 5 && trim.step >= 2) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    } else if (step == 7) { // for thickness
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= 6 && thick.step >= 1) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    } else {
      if (activeStep == step) {
        return `${style.button} ${style.buttonSelected}`;
      } else if (activeStep >= step-1) {
        return style.button;
      } else {
        return style.buttonDisable;
      }
    }
  }
  
  /**
   * Returns a boolean indicating whether a step is disabled or not.
   * @param {number} step - The step number to check.
   * @returns {boolean} - True if the step is disabled, false otherwise.
   */
  const getDisabled = (step) => {
    if (step == 1) { // for marking
      if (activeStep >= step && align.step >= 3) {
        return false;
      } else {
        return true;
      }
    } else if (step == 4) { // for compress
      if (activeStep >= step && compress.step >= 1) {
        return false;
      } else {
        return true;
      }
    } else if (step == 5) { // for trimming
      if (activeStep >= step && trim.step >= 2) {
        return false;
      } else {
        return true;
      }
    } else if (step == 6) { // for thickness
      if (activeStep >= step && thick.step >= 1) {
        return false;
      } else {
        return true;
      }
    } else {
      if (activeStep >= step) {
        return false;
      } else {
        return true;
      }
    }
  }

  // onclick bindling way is not proper, we would need to change function to class and use bind function.
  return(
    <div>
      <Box className={style.moduleTitle}>WorkFlow</Box>

      <div className={style.workflow}>
        {/* Line 1 */}
        <Grid container spacing={1} alignItems='center'>
          {/* Setup */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}></Grid>
              <Grid item xs={10}>
                <Button className={getActive(0)} onClick={() => onClick(0)} size="small">Setup</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* Alignment */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(1)} onClick={() => onClick(1)} size="small">Alignment</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* Marking */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(2)} onClick={() => onClick(2)} disabled={getDisabled(1)} size="small">Marking</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* Modifying */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(3)} onClick={() => onClick(3)} disabled={getDisabled(2)} size="small">Modifying</Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>

        {/* Line 2 */}
        <Grid container spacing={1} alignItems='center'>
          {/* Compress */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(4)} onClick={() => onClick(4)} disabled={getDisabled(3)} size="small">Compress</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* Trimming */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(5)} onClick={() => onClick(5)} disabled={getDisabled(4)} size="small">Trimming</Button>
              </Grid>
            </Grid>
          </Grid>


          {/* Thickness */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(6)} onClick={() => onClick(6)} disabled={getDisabled(5)} size="small">Thickness</Button>
              </Grid>
            </Grid>
          </Grid>

          {/* Output */}
          <Grid item xs={3}>
            <Grid container direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <Grid item xs={2}>
                <FontAwesomeIcon icon={['fas', 'angle-double-right']} />
              </Grid>
              <Grid item xs={10}>
                <Button className={getActive(7)} onClick={() => onClick(7)} disabled={getDisabled(6)} size="small">Output</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
export default WorkflowTest;
